export default "__VITE_ASSET__CMYWSBun__"